import Documents from '../../../components/Common/Documents/DocumentsCont'
import EmployeeLoanForm from '../../../components/People/EmployeeLoan/EmployeeLoanForm'
import PaymentScheduleCont from '../../../components/People/EmployeeLoan/Lines/PaymentScheduleCont'
import style from '../../../components/Sales/style.css'
import CustomSpin from '../../../elements/CustomSpin'
import Status from '../../../elements/Status'
import { strVal } from '../../../modules/Utils'
import React, { Fragment } from 'react'
import { Modal, Popconfirm, Row, Tabs } from 'antd'
import FooterButtons from '../../../elements/Buttons/FooterButtons'
import _ from 'lodash'

const { TabPane } = Tabs

function EmployeeLoanModal(props) {
  const {
    visible,
    modalType,
    submitting,
    submit,
    update,
    formRef,
    onCancel,
    removing,
    remove,
    employeeLoan,
    actions,
    handleActions,
    fetchingActions,
  } = props

  const isNew = modalType === 'new'
  const Operations = ({ employeeLoan, ...rest }) => {
    const ops = actions
      .filter((a) => a.key !== 'update' && a.key !== 'remove')
      .map((a) => (
        <span>
          <Popconfirm
            placement="left"
            title={`Are you sure to ${a.value}?`}
            onConfirm={() => handleActions(a.key)}
            okText="Yes"
            cancelText="No">
            <a>{a.value}</a>
          </Popconfirm>
        </span>
      ))

    return (
      <div {...rest}>
        {ops.length > 0 ? ops.reduce((prev, curr) => [prev, <span className="ant-divider" />, curr]) : []}
      </div>
    )
  }

  return (
    <Modal
      visible={visible}
      title={'Employee Loan'}
      onCancel={onCancel}
      destroyOnClose={true}
      footer={
        <FooterButtons
          remove={remove}
          removing={removing}
          submit={submit}
          update={update}
          submitting={submitting}
          title={'Employee Loan'}
          isNew={isNew}
          isEdit={!isNew}
        />
      }
      width={'85%'}>
      <CustomSpin spinning={fetchingActions}>
        <h3 className={style.title}>
          {!isNew && (
            <Fragment>
              <Status value={_.capitalize(employeeLoan.status)} />
              <Operations
                style={{ marginTop: '10px' }}
                employeeLoan={employeeLoan}
                status={strVal(employeeLoan, 'status')}
              />
            </Fragment>
          )}
        </h3>
      </CustomSpin>
      <Tabs defaultActiveKey="form">
        <TabPane tab="Form" key="form">
          <Row>
            <EmployeeLoanForm ref={formRef} {...props} />
          </Row>
        </TabPane>
        <TabPane disabled={isNew} tab={'Repayment'} key="#Repayment">
          <PaymentScheduleCont employeeLoan={employeeLoan} />
        </TabPane>
        <TabPane disabled={isNew} tab="Files" key="files">
          <Documents editable={true} footer={false} category={false} owner={employeeLoan} />
        </TabPane>
      </Tabs>
    </Modal>
  )
}

EmployeeLoanModal.propTypes = {}
EmployeeLoanModal.defaultProps = {}

export default EmployeeLoanModal
